export default __webpack_public_path__ + "static/internalesgdk-2ba4905b99f2290b8d5941e20c749fc8.jpg";